'use strict';
var trackingUtils = require('../modules/utils/tracking.utils');
Odigeo.defineWidget('download_app_banner', Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend({
        categoryItem: null,
    }),
    viewClass: Odigeo.View.extend({
        templateSettings: {
            evaluate: /\{\{#([\s\S]+?)\}\}/g,
            interpolate: /\{\{[^#{]([\s\S]+?)[^}]\}\}/g,
            escape: /\{\{\{([\s\S]+?)\}\}\}/g,
        },
        selectors: {
            linkFooter: '.footer_image_link',
        },
        init: function() {
            this.$cachedSelectors.linkFooter.off().on(Odigeo.Events.tap, _.bind(this.linkFooterTrack, this));
        },
        linkFooterTrack: function(e) {
            var $eventTarget;
            var label;
            var category;
            var trackingData;

            $eventTarget = $(e.currentTarget);
            $eventTarget.attr('href', trackingUtils.decorateAppTouchpointUrl($eventTarget.attr('href')));

            label = _.property($eventTarget.data('type'))({
                'apple': 'apps_open_market_apple',
                'android': 'apps_open_market_android',
            });
            category = this.model.categoryItem ? this.model.categoryItem : $eventTarget.data('track-category');
            trackingData = {
                category: category,
                action: 'apps_download',
                label: label,
            };
            // Analytics: event tracking
            Odigeo.trigger('analytics:tracking', {
                type: 'trackEvent',
                data: trackingData,
            });
        },
    }),
    trackEventCategory: function(data) {
        this.model.categoryItem = data;
    },
    dataTrack: function(data) {
        this.view.$cachedSelectors.linkFooter.data('track-category', data);
    },
}));
